import { render, staticRenderFns } from "./Default.vue?vue&type=template&id=529986f6&"
import script from "./Default.vue?vue&type=script&lang=ts&"
export * from "./Default.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {NavBar: require('/builds/simistry/gm/graduatemastery.com-nuxt/site/components/NavBar.vue').default,FooterBar: require('/builds/simistry/gm/graduatemastery.com-nuxt/site/components/FooterBar.vue').default})
